module.exports = __webpack_public_path__ + "static/media/390x310-New-Orleans.42de082e.jpg";